var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindVaneBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9978 3.47322L10.6235 7.66657L9.37723 7.66657V7.25241C9.37723 6.87323 9.06985 6.56585 8.69068 6.56585C8.3115 6.56585 8.00412 6.87323 8.00412 7.2524V7.66657L1.95544 7.66658C1.61222 7.66658 1.33398 7.94481 1.33398 8.28803C1.33398 8.63125 1.61222 8.90949 1.95544 8.90949H8.00412V15.5015H7.54879C7.32787 15.5015 7.14879 15.6806 7.14879 15.9015V16.6107C7.14879 16.8316 7.32787 17.0107 7.54879 17.0107H9.85607C10.077 17.0107 10.2561 16.8316 10.2561 16.6107V15.9015C10.2561 15.6806 10.077 15.5015 9.85607 15.5015H9.37723V8.90949H17.4031C17.9661 8.90949 18.4417 8.5351 18.5945 8.02169H18.6673V5.72453C18.6673 4.25662 17.4773 3.06665 16.0094 3.06665C15.6324 3.06665 15.2699 3.21232 14.9978 3.47322Z",
    fill: "#1E2447"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindVaneBlue);
export default __webpack_public_path__ + "static/media/WindVane_Blue.83288e10.svg";
export { ForwardRef as ReactComponent };